const SideMenu = [
  { 
    title: 'dashboard_title',
    to: '/',
    icon: 'mdi-view-dashboard',
    children: [] 
  },
  { 
    title: 'reports',
    to: '/reports',
    icon: 'mdi-chart-bar',
    children: [] 
  },
  { 
    title: 'catalogue', 
    to: '', 
    icon: 'mdi-format-list-bulleted-square', 
    children: [
      {
        title: 'catalogue',
        to: '/catalogue',
        icon: 'fa-list',
        exact: true
      },
      {
        title: 'custom_lists',
        to: '/catalogue/custom-lists',
        icon: ''
      },
      {
        title: 'warehouse',
        to: '/catalogue/warehouses',
        icon: ''
      }
    ]
  },
  { 
    title: 'order', 
    to: '/orders', 
    icon: 'mdi-file-cog-outline', 
    children: [
      {
        title: 'order',
        to: '/orders',
        icon: 'fa-list',
        exact: true
      },
      {
        title: 'quotation',
        to: '/quotations',
        icon: ''
      },
      {
        title: 'invoicing_title',
        to: '/invoicing',
        icon: ''
      }
    ]
  },
  { 
    title: 'shipping', 
    to: '/shipments', 
    icon: 'mdi-ferry', 
    children: []
  },
  { 
    title: 'client', 
    to: '/companies', 
    icon: 'mdi-account-multiple', 
    children: []
  }
]

export default SideMenu